import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse'
import intersect from '@alpinejs/intersect'
import mask from '@alpinejs/mask'
import header from "./blocks/header";
import headerNavigationItem from "./blocks/header-navigation-item";
import headerContacts from "./blocks/header-contacts";
import countries from "./blocks/countries";
import opportunities from "./blocks/opportunities";
import students from "./blocks/students";
import timeLine from "./blocks/time-line";
import latestNews from "./blocks/latestNews";
import partners from "./blocks/partners";
import faq from "./blocks/faq";
import accordionItem from "./components/accordionItem";
import tableOfContent from "./components/tableOfContent";
import blogPostPage from "./blocks/blogPostPage";
import blogCard from "./components/blogCard";
import preloader from "./blocks/preloader";
import checkbox from './components/checkbox';
import leadForm from './blocks/leadForm';
import textField from './components/textField';
import radio from './components/radio';
import blog from './blocks/blog';
import responsive from './stores/responsive';
import body from './stores/body';
import sidebarLayout from './blocks/sidebarLayout';
import testimonials from './blocks/testimonials';
import modal from './components/modal';
import review from './components/review';
import modalWrapper from './components/modalWrapper';
import truncateText from './components/truncateText';
import tooltip from './components/tooltip';
import copyText from './components/copyText';
import counter from './components/counter';
import scrollToTop from './blocks/scrollToTop';
import popupForm from "./blocks/popupForm";
import formStatusPopupStore from "./stores/formStatusPopupStore";
import callbackForm from "./blocks/callbackForm";
import footer from "./blocks/footer";
import subscribeForm from "./blocks/subscribeForm";
import {DESKTOP_HEADER_HEIGHT, PHONE_HEADER_HEIGHT} from "./constants";
import button from "./components/button";

window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.plugin(intersect);
Alpine.plugin(mask)

document.addEventListener('alpine:init', () => {
    Alpine.store('responsive', responsive);
    Alpine.store('body', body);
    Alpine.store('formStatusPopup', formStatusPopupStore);
    Alpine.data('header', header);
    Alpine.data('headerNavigationItem', headerNavigationItem);
    Alpine.data('headerContacts', headerContacts);
    Alpine.data('countries', countries);
    Alpine.data('opportunities', opportunities);
    Alpine.data('students', students);
    Alpine.data('timeLine', timeLine);
    Alpine.data('latestNews', latestNews);
    Alpine.data('partners', partners);
    Alpine.data('faq', faq);
    Alpine.data('accordionItem', accordionItem);
    Alpine.data('tableOfContent', tableOfContent);
    Alpine.data('blogPostPage', blogPostPage);
    Alpine.data('blogCard', blogCard);
    Alpine.data('preloader', preloader);
    Alpine.data('checkbox', checkbox);
    Alpine.data('radio', radio);
    Alpine.data('leadForm', leadForm);
    Alpine.data('textField', textField);
    Alpine.data('blog', blog);
    Alpine.data('sidebarLayout', sidebarLayout);
    Alpine.data('testimonials', testimonials);
    Alpine.data('modal', modal);
    Alpine.data('modalWrapper', modalWrapper);
    Alpine.data('review', review);
    Alpine.data('truncateText', truncateText);
    Alpine.data('tooltip', tooltip);
    Alpine.data('copyText', copyText);
    Alpine.data('counter', counter);
    Alpine.data('scrollToTop', scrollToTop);
    Alpine.data('popupForm', popupForm);
    Alpine.data('callbackForm', callbackForm);
    Alpine.data('subscribeForm', subscribeForm);
    Alpine.data('footer', footer);
    Alpine.data('button', button);
});

Alpine.start();

document.addEventListener("DOMContentLoaded", function() {
    // Находим все ссылки на странице
    const allLinks = document.querySelectorAll('a');

    // Обходим все найденные ссылки
    allLinks.forEach(function(link) {
        // Навешиваем обработчик события на клик
        link.addEventListener('click', function(e) {

            // Получаем путь и якорь из ссылки
            const urlParts = this.href.split('#');
            const path = urlParts[0];
            const hash = urlParts[1];

            // Проверяем, является ли ссылка якорной и содержит ли она символ #
            if (this.href.indexOf('#') !== -1) {
                // Предотвращаем стандартное поведение ссылки
                e.preventDefault();
                // Проверяем, принадлежит ли якорь к текущей странице
                if (path === window.location.pathname + window.location.search || path === window.location.protocol + '//' + window.location.hostname + window.location.pathname + window.location.search) {
                    // Если якорь относится к текущей странице, прокручиваем до элемента
                    const targetElement = document.getElementById(hash);
                    if (targetElement) {
                        const offsetTop = targetElement.offsetTop;
                        const headerHeight = Alpine.store('responsive').isDesktop || Alpine.store('responsive').isTablet ? DESKTOP_HEADER_HEIGHT : PHONE_HEADER_HEIGHT;
                        window.scrollTo({
                            top: offsetTop > headerHeight ? offsetTop - 74 : offsetTop,
                            behavior: 'smooth'
                        });
                    }
                } else {
                    // Если якорь относится к другой странице, переходим по ссылке
                    window.location.href = this.href;
                }
            } else {
                if (path === window.location.protocol + '//' + window.location.hostname + window.location.pathname + window.location.search) {
                    e.preventDefault();
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                }
            }
        });
    });
});
